module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "page1 animated fadeIn"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('div', {
    staticClass: "left-side"
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.items.intro2.title))]), _vm._v(" "), _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.items.intro2.text)
    }
  })]), _vm._v(" "), _vm._m(0)])])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "right-side"
  }, [_c('img', {
    attrs: {
      "src": "media/intros/chart_1.png"
    }
  })])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-399edf88"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/containers/section1/pages/Page1.vue
// module id = 132
// module chunks = 0